import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors } from "@angular/common/http";
import {
  APP_INITIALIZER,
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
} from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule, provideAnimations } from "@angular/platform-browser/animations";
import { JWT_OPTIONS, JwtHelperService } from "@auth0/angular-jwt";
import { provideHttpCache, provideHttpCacheLocalStorageStrategy, withHttpCacheInterceptor } from "@ngneat/cashew";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { provideStoreDevtools } from "@ngrx/store-devtools";
import { SedsHeaderModule, SedsModalModule } from "@serasa/shared/seds";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { CoreModule } from "./core/core.module";
import { PrivacyModule } from "./core/modules/privacy/privacy.module";
import { RenovateInterceptor } from "./shared/interceptors/renovate.interceptor";
import { SharedModule } from "./shared/shared.module";
import { InvalidateCacheInterceptor } from "./shared/interceptors/invalidate-cache.interceptor";

function initializeApp(): void {
  localStorage.removeItem("mat-paginator");
}

@NgModule({
  declarations: [ AppComponent ],
  imports: [
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    CoreModule,
    EffectsModule.forRoot(),
    FormsModule,
    PrivacyModule,
    ReactiveFormsModule,
    SedsHeaderModule,
    SedsModalModule,
    SharedModule,
    StoreModule.forRoot({}),
  ],
  providers: [
    provideAnimations(),
    provideStoreDevtools({
      maxAge: 25
    }),
    provideHttpClient(withInterceptors([withHttpCacheInterceptor()])),
    provideHttpCache({ strategy: 'explicit' }),
    provideHttpCacheLocalStorageStrategy(),
    JwtHelperService,
    { provide: JWT_OPTIONS, useValue: JWT_OPTIONS },
    { provide: 'CACHE_EXPIRATION', useValue: 600000 }, // 10 minutos
    {
      provide: APP_INITIALIZER,
      useFactory: () => initializeApp,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InvalidateCacheInterceptor,
      multi: true
    },    
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RenovateInterceptor,
      multi: true
    }, 
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule { }
